import angular from 'angular';

import CalendarCheckboxComponent from './calendar-checkbox.cmpt';

export default angular
    .module('application.component.calendar-checkbox', [])
    .component(CalendarCheckboxComponent.selector, CalendarCheckboxComponent);



// WEBPACK FOOTER //
// ./src/application/component/calendar-checkbox/index.js